<template>
  <section class="main">
    <h1 class="intro"><slot name="heading" /></h1>
    <loader v-if="loading" />
    <div v-else class="row">
      <div class="row__col_grow">
        <slot />
      </div>
      <div v-if="$slots.sidebar" class="desc">
        <slot name="sidebar" />
      </div>
    </div>
  </section>
</template>

<script>
import Loader from '@/components/Loader';

export default {
  components: { Loader },
  props: {
    loading: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables";

.main {
  display: block;
  flex-grow: 1;
  min-width: 0;
}

.row {
  display: flex;
  align-items: flex-start;

  @include notebook {
    flex-direction: column-reverse;
  }

  &__col {
    &_grow {
      flex-grow: 1;
      min-width: 0;
      max-width: 100%;

      @include notebook {
        width: 100%;
      }
    }
  }
}

.desc {
  background: var(--secondary-bg);
  border-radius: 8px;
  flex: 0 0 200px;
  margin-left: 40px;
  padding: 10px;

  @include notebook {
    margin: 0 0 15px;
    flex: 0 0 auto;
  }

  &::v-deep {
    p:not(:last-child) {
      margin-bottom: 15px;
    }
  }
}
</style>
